var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBubblemaps(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 32C25.3366 32 32.5 24.8366 32.5 16C32.5 7.16344 25.3366 0 16.5 0C7.66344 0 0.5 7.16344 0.5 16C0.5 24.8366 7.66344 32 16.5 32Z",
    fill: "#141023"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3792 13.7557C17.5092 12.1461 18.9502 9.60027 18.9502 9.60027C18.9502 9.60027 21.7351 9.53984 22.6052 11.1495L26.5728 18.4902C27.2466 19.7367 26.846 21.3314 25.6797 22.0506C24.5135 22.7699 23.0206 22.343 22.3469 21.0964L18.3792 13.7557Z",
    fill: "url(#paint0_linear_2168_991)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3792 13.7557C9.50917 12.1461 10.9502 9.60027 10.9502 9.60027C10.9502 9.60027 13.7351 9.53984 14.6052 11.1495L18.5728 18.4902C19.2466 19.7367 18.846 21.3314 17.6797 22.0506C16.5135 22.7699 15.0206 22.343 14.3469 21.0964L10.3792 13.7557Z",
    fill: "url(#paint1_linear_2168_991)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33806 22.1619C6.33806 22.1619 5.57215 19.5208 6.78779 18.3051C7.72813 17.3648 9.25475 17.3651 10.1948 18.3051C11.1349 19.2452 11.1352 20.7718 10.1948 21.7122C8.97919 22.9278 6.33806 22.1619 6.33806 22.1619Z",
    fill: "url(#paint2_linear_2168_991)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2168_991",
    x1: 25.6797,
    y1: 22.0506,
    x2: 18.263,
    y2: 10.0245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3054B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2168_991",
    x1: 17.6797,
    y1: 22.0506,
    x2: 10.263,
    y2: 10.0245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C41BAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F52586"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2168_991",
    x1: 10.1948,
    y1: 18.3051,
    x2: 6.33841,
    y2: 22.1615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F17BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B038FA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubblemaps);
export default __webpack_public_path__ + "static/media/bubblemaps.9a96b5c51a9d374ff33205da26dfb8e5.svg";
export { ForwardRef as ReactComponent };